import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'userSessions'

const listSessions = (axios: IFactoryFunctionRequest) => (query: { page: number; limit: number; search?: string }): IFactoryResponse<any> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    query,
  })
}

const revokeSession = (axios: IFactoryFunctionRequest) => (sessionId: string): IFactoryResponse<any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${sessionId}/revoke`,
  })
}

const revokeAllUserSessions = (axios: IFactoryFunctionRequest) => (userId: string): IFactoryResponse<any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/user/${userId}/revoke-all`,
  })
}

const blockUser = (axios: IFactoryFunctionRequest) => (userId: string): IFactoryResponse<any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/user/${userId}/block`,
  })
}

const unblockUser = (axios: IFactoryFunctionRequest) => (userId: string): IFactoryResponse<any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/user/${userId}/unblock`,
  })
}

const listBlockedUsers = (axios: IFactoryFunctionRequest) => (): IFactoryResponse<any> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/blocked-users`,
  })
}

export default (axios: AxiosInstance) => ({
  listSessions: listSessions(useAxios(axios)),
  revokeSession: revokeSession(useAxios(axios)),
  revokeAllUserSessions: revokeAllUserSessions(useAxios(axios)),
  blockUser: blockUser(useAxios(axios)),
  unblockUser: unblockUser(useAxios(axios)),
  listBlockedUsers: listBlockedUsers(useAxios(axios)),
})
